
import { acCertificatesTypes } from '../acReduxExports'


const acCertificateInitialState: AcCertificatesState = {
  loader: false,
  acChargerCertificatesInfo:null,
  acChargerCertificatesInfoCount:0,
  acChargerCertificatesInfoListTableProps: {
    view: 'list',
    sortBy: 'createdAt',
    order: 'descending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: ''
  },
  acChargerCertificatesInfoListRequestSearchHash: null,
  acChargerCertificatesInfoListRequestFilterHash: null
}

const acCertificatesReducer = ( state: AcCertificatesState = acCertificateInitialState, action: AcCertificatesAction) => {
    switch (action.type) {
        case acCertificatesTypes.SET_AC_CERTIFICATES_LOADER:
            return {
                ...state,
                loader: action.loader
            }
        case acCertificatesTypes.FETCH_AC_CHARGER_CERTIFICATES_INFO_DATA:
            return {
                ...state,
                acChargerCertificatesInfo: action.acChargerCertificatesInfo,
                acChargerCertificatesInfoCount: action.acChargerCertificatesInfoCount
            }

        case acCertificatesTypes.SET_AC_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS:
            return {
                ...state,
                acChargerCertificatesInfoListTableProps: action.acChargerCertificatesInfoListTableProps
            }
        case acCertificatesTypes.CLEAR_AC_CHARGER_CERTIFICATES_INFO_LIST_DATA:
            return {
                ...acCertificateInitialState
            }
        case acCertificatesTypes.SET_AC_CHARGER_CERTIFICATES_LIST_REQUEST_HASH:
            return {
                ...state,
                acChargerCertificatesInfoListRequestSearchHash: action.acChargerCertificatesInfoListRequestSearchHash || null,
                acChargerCertificatesInfoListRequestFilterHash: action.acChargerCertificatesInfoListRequestFilterHash || null
            };

        default: 
            return state;
        
    }
}

export default acCertificatesReducer;
